import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardTitle, Form, Spinner } from 'reactstrap';
import { Dispatch } from 'redux';
import { sendPasswordReset } from '../../../stores/auth/actionCreators';
import { isLoading } from '../../../stores/navigation/selectors';
import { RootState } from '../../../stores/store';
import FormInput from '../../common/FormInput';
import { LoadingButton } from '../../navigation/LoadingButton';

interface Props extends LocalizeContextProps, RouteComponentProps {
    dialogType: 'forgot' | 'change';
    loading: boolean;

    sendPasswordReset: (email: string) => void;
}

interface State {
    email: string;
}

class ForgotPasswordDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            email: '',
        };
    }

    public handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            [event.target.name]: event.target.type === 'checkbox' ?
                event.target.checked : event.target.value,
            // tslint:disable-next-line:no-any
        } as any);
    }

    // tslint:disable-next-line:no-any
    public sendResetPassword = (e: React.SyntheticEvent<any, Event>) => {
        e.preventDefault();
        this.props.sendPasswordReset(this.state.email);
    }

    public render() {
        const t = this.props.translate;
        return (
            <Card>
                <CardBody>
                    {this.props.dialogType === 'forgot' ?
                        <CardTitle tag="h3">{t('forgotPassword.header.forgotPassword')}</CardTitle>
                        : <CardTitle tag="h3">{t('forgotPassword.header.changePassword')}</CardTitle>}
                    <Form>
                        <FormInput
                            name="email"
                            fullName={t('forgotPassword.field.email') as string}
                            value={this.state.email}
                            onChange={this.handleInputChange}
                            type="text"
                        />
                        <LoadingButton
                            fixedWidth={true}
                            color="primary"
                            className={classnames('float-right', 'save-btn', 'loginBtn')}
                            type="submit"
                            loading={this.props.loading}
                            onClick={this.sendResetPassword}
                            onSubmit={this.sendResetPassword}
                        >
                            {t('forgotPassword.button.send')}
                        </LoadingButton>

                        {this.props.dialogType === 'forgot' ?
                            (
                                <Link to={{ pathname: '/login', state: { from: this.props.location } }} >
                                    {t('forgotPassword.link.backToLogin')}
                                </Link>
                            ) : (
                                <Link to={{ pathname: '/select-app', state: { from: this.props.location } }} >
                                    {t('forgotPassword.link.backToApps')}
                                </Link>
                            )
                        }
                    </Form>
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    loading: isLoading(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendPasswordReset: (email: string) => dispatch(sendPasswordReset(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ForgotPasswordDialog)));
